import axios from '../axios';

// 学历维护列表
export const getBaseSchoolingExpPage = data => {
    return axios({
        url: '/api/sys/getBaseSchoolingExpPage',
        method: 'post',
        data
    })
};

// 增加
export const saveBaseSchoolingExp = data => {
    return axios({
        url: '/api/sys/saveBaseSchoolingExp',
        method: 'post',
        data
    })
};

// 修改
export const updateBaseSchoolingExp = data => {
    return axios({
        url: '/api/sys/updateBaseSchoolingExp',
        method: 'post',
        data
    })
};

// 删除
export const deleteBaseSchoolingExps = data => {
    return axios({
        url: '/api/sys/deleteBaseSchoolingExps',
        method: 'post',
        data
    })
};

// 查询单条记录信息
export const getBaseSchoolingExpById = data => {
    return axios({
        url: '/api/sys/getBaseSchoolingExp',
        method: 'post',
        data
    })
};

// 审核/反审核
export const checkChangeBaseSchoolingExp = data => {
    return axios({
        url: '/api/sys/checkChangeBaseSchoolingExp',
        method: 'post',
        data
    })
};






// WEBPACK FOOTER //
// ./src/api/moudules/BaseSchoolingExp.js